(() => {
  "use strict";
  function e(e = document.body, t = !0) {
    const o = e.querySelectorAll("*"),
      n = {};
    return (
      o.forEach((e) => {
        e.getAttributeNames().forEach((o) => {
          if (o.startsWith("data-")) {
            const i = ((e) =>
              e
                .split("-")
                .slice(1)
                .map((e, t) => (0 == t ? e : e[0].toUpperCase() + e.slice(1)))
                .join(""))(o);
            t
              ? (n[i] || (n[i] = []), n[i].push(e))
              : void 0 === n[i]
              ? (n[i] = e)
              : Array.isArray(n[i])
              ? n[i].push(e)
              : (n[i] = [n[i], e]);
          }
        });
      }),
      n
    );
  }
  function t() {
    return fetch(`${window.Phill.routes.cart}.js`, {
      method: "GET",
      credentials: "include",
    }).then((e) => e.json());
  }
  function o(e, o, n = {}) {
    return (function (e = []) {
      return (
        window.app.emit("cart:updating"),
        fetch(`${window.Phill.routes.cartAdd}.js`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: e }),
        })
          .then((e) => e.json())
          .then(async (e) => {
            if (e.status)
              return (
                window.app.emit(["cart:updated", "cart:error"], null, e),
                {
                  item: e,
                  cart: window.app.getState().cart,
                  error: e?.description,
                }
              );
            const [o, n] = await Promise.all([
              t(),
              fetch(`${window.Phill.routes.cart}?sections=cart-drawer`, {
                method: "GET",
                credentials: "include",
              }).then((e) => e.json()),
            ]);
            return (
              (o.sections = n),
              window.app.emit(["cart:updated", "cart:render"], { cart: o }),
              { item: e, cart: o }
            );
          })
      );
    })([{ id: e, quantity: o, properties: n }]);
  }
  const n = (e) =>
    e.split(".").reduce((e, t) => e?.[t], window?.Phill?.theme?.strings) ||
    `Missing translation for ${e} in window.Phill`;
  function i(e, t = window.Phill.money_format) {
    "string" == typeof e && (e = e.replace(".", ""));
    let o = "";
    const n = /\{\{\s*(\w+)\s*\}\}/;
    function i(e, t, o, n) {
      if (
        (void 0 === t && (t = 2),
        (n = "," == (o = window.Phill.money_separator) ? "." : ","),
        isNaN(e) || null == e)
      )
        return 0;
      const i = (e = (e / 100).toFixed(t)).split(".");
      return (
        i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) +
        (i[1] ? n + i[1] : "")
      );
    }
    switch (t.match(n)[1]) {
      case "amount":
      case "amount_with_comma_separator":
      case "amount_with_space_separator":
        o = i(e, 2);
        break;
      case "amount_no_decimals":
      case "amount_no_decimals_with_comma_separator":
      case "amount_no_decimals_with_space_separator":
        o = i(e, 0);
    }
    return t.replace(n, o);
  }
  function r({ product: e, variant: t, option1: o, option2: n, option3: i }) {
    const r = e.variants.reduce(
        (e, t) => (
          t.available &&
            (e[t.option1] || (e[t.option1] = {}),
            e[t.option1][t.option2]
              ? e[t.option1][t.option2].push(t.option3)
              : (e[t.option1][t.option2] = t.option3 ? [t.option3] : [])),
          e
        ),
        {}
      ),
      a = e.variants.reduce(
        (e, t) => (
          e[t.option1] || (e[t.option1] = {}),
          e[t.option1][t.option2]
            ? e[t.option1][t.option2].push(t.option3)
            : (e[t.option1][t.option2] = t.option3 ? [t.option3] : []),
          e
        ),
        {}
      ),
      c = Object.keys(r),
      d = Object.keys(r?.[t.option1] || {}),
      s = r?.[t.option1]?.[t.option2] || [],
      l = Object.keys(a),
      p = Object.keys(a?.[t.option1] || {}),
      u = a?.[t.option1]?.[t.option2] || [],
      m = (e, t, o) => {
        e.forEach((e) => {
          if (e) {
            const n = e.parentNode.querySelector("label"),
              i = e.value;
            n[t.includes(i) ? "removeAttribute" : "setAttribute"](
              "disabled",
              ""
            ),
              e[o.includes(i) ? "removeAttribute" : "setAttribute"](
                "disabled",
                ""
              );
          }
        });
      };
    m([].concat(o), c, l), m([].concat(n), d, p), m([].concat(i), s, u);
  }
  function a({
    option1: e,
    option2: t,
    option3: o,
    option1Out: n,
    option2Out: i,
    option3Out: r,
  }) {
    [].concat(e).forEach((e) => {
      e?.checked && n && (n.innerHTML = e.value);
    }),
      [].concat(t).forEach((e) => {
        e?.checked && i && (i.innerHTML = e.value);
      }),
      [].concat(o).forEach((e) => {
        e?.checked && r && (r.innerHTML = e.value);
      });
  }
  function c({ price: e, compareAtPrice: t, variant: o }) {
    const n = o.price,
      r = o.compare_at_price;
    (e.innerHTML = i(n)), (t.innerHTML = r > n ? i(r) : "");
  }
  function d({
    product: e,
    option: t,
    productMainSelect: o,
    variantChange: n,
  }) {
    const i = []
        .concat(t)
        .reduce((e, t) => (t?.checked && e.push(t.value), e), []),
      r = [...o.querySelectorAll("option")].find(
        (e) => e.innerText.split(" / ").sort().join() === [...i].sort().join()
      );
    r && ((o.value = r.value), n(e.variants.find((e) => +e.id == +r.value)));
  }
  const s = window.component((i, s) => {
      const {
          productMainSelect: l,
          price: p,
          compareAtPrice: u,
          form: m,
          submit: w,
          option1Out: h,
          option2Out: v,
          option3Out: f,
          option: g,
          option1: y,
          option2: b,
          option3: L,
          sizeguideTrigger: E,
          productDetailsTrigger: S,
          finishthelookTrigger: k,
          backinstock: _,
          backinstockInput: x,
          loyaltyProduct: T,
          infoBanner: A,
        } = e(i, !1),
        { product: P } = JSON.parse(
          i.querySelector(".js-product-json").innerHTML
        );
      if ("true" === T.dataset.loyaltyProduct) {
        const e =
            m.elements.id.value ||
            m.elements.id.querySelector("[selected]").value,
          t = ({ cart: t }) => {
            const o = t?.items.filter((t) => t.id === Number(e)) || [];
            var i;
            (i =
              (o[0]?.quantity || 0) + Number(T.dataset.claimedRewardQuantity) >=
              T.dataset.cartLimit),
              A.classList.toggle("hidden", !i),
              (A.textContent = n("product.loyalty_limit").replace(
                "{{ product_limit }}",
                T.dataset.cartLimit
              )),
              (w.disabled = i);
          };
        window.app.on("cart:updated", t);
      }
      const O = ({ cart: e, variant: t }) => {
          let o = 0;
          const r = [];
          let a = !1;
          if (
            ([].concat(g).forEach((n) => {
              if (
                n.checked &&
                o <= parseInt(n.dataset.optionsAmount, 10) &&
                t.inventory_management &&
                (o++, n.dataset.optionIndex == o)
              ) {
                const o =
                  e.items.find((e) => e.variant_id == t.id)?.quantity || 0;
                (a = t.inventory_quantity - o <= t.inventory_buffer),
                  r.push(a),
                  n?.nextElementSibling.toggleAttribute("disabled", a);
              }
            }),
            "true" === !T.dataset.loyaltyProduct)
          ) {
            const e = r.includes(!0);
            let t = e ? n("product.sold_out") : w.dataset.text;
            void 0 !== i.dataset.productPreorder &&
              (t = n(e ? "product.coming_soon" : "product.preorder")),
              (function ({ submit: e, disabled: t, text: o }) {
                e.toggleAttribute("disabled", t), (e.textContent = o);
              })({ submit: w, disabled: e, text: t });
          }
        },
        M = async (e) => {
          const o = new URL(window.location.href),
            n = new URLSearchParams(o.search.slice(1));
          if (
            (n.set("variant", e.id),
            window.history.replaceState(
              {},
              "",
              `${window.location.pathname}?${n.toString()}`
            ),
            _ &&
              (_.classList[e.available ? "add" : "remove"]("hidden"),
              x && (x.value = e.id)),
            s.emit("variant:change", { variant: e }),
            "true" !== T.dataset.loyaltyProduct &&
              c({ price: p, compareAtPrice: u, variant: e }),
            r({ product: P, variant: e, option1: y, option2: b, option3: L }),
            a({
              option1: y,
              option2: b,
              option3: L,
              option1Out: h,
              option2Out: v,
              option3Out: f,
            }),
            g)
          ) {
            const o = await t();
            O({ cart: o, variant: e });
          }
        };
      g &&
        (d({ product: P, option: g, productMainSelect: l, variantChange: M }),
        [].concat(g).forEach((e) => {
          e.addEventListener("change", () => {
            d({
              product: P,
              option: g,
              productMainSelect: l,
              variantChange: M,
            });
          });
        })),
        m.addEventListener("submit", (e) => {
          e.preventDefault(),
            w.toggleAttribute("loading", !0),
            o(
              m.elements.id.value ||
                m.elements.id.querySelector("[selected]").value,
              m.elements.quantity.value
            ).then(({ error: e }) => {
              e && alert(e),
                setTimeout(() => {
                  s.emit("drawer-cart", { "drawer-cart": { open: !0 } });
                }, 300),
                T.dataset.loyaltyProduct || w.toggleAttribute("loading", !1);
            });
        });
      const q = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            e.isIntersecting &&
              (w.classList.toggle("fixed"), q.unobserve(e.target));
          });
        },
        { threshold: 1 }
      );
      window.innerWidth < 640 && q.observe(w);
      let C = window.innerWidth;
      window.addEventListener("resize", () => {
        C !== window.innerWidth &&
          (window.innerWidth < 640
            ? (q.observe(w), (C = window.innerWidth))
            : (q.unobserve(w), w.classList.remove("fixed")));
      }),
        E?.addEventListener("click", (e) => {
          e.preventDefault(),
            s.emit("drawer-sizeguide", { "drawer-sizeguide": { open: !0 } });
        }),
        S?.addEventListener("click", (e) => {
          e.preventDefault(),
            s.emit("drawer-product-details", {
              "drawer-product-details": { open: !0 },
            });
        }),
        k?.addEventListener("click", (e) => {
          e.preventDefault(),
            s.emit("drawer-finishthelook", {
              "drawer-finishthelook": { open: !0 },
            });
        }),
        s.on("cart:updated", ({ cart: e }) => {
          if (!e?.token) return;
          const t = new URLSearchParams(window.location.search),
            o = P.variants.find((e) => e.id == t.get("variant"));
          g && O({ cart: e, variant: o });
        });
    }),
    l = (e) =>
      new Promise((t) => {
        window?.hasLoaded?.scripts?.[e] ? t() : window.app.on(`${e}:loaded`, t);
      });
  function p(e) {
    let t, o, n;
    function i(t, n) {
      (o.x -= t.deltaX),
        (o.y -= t.deltaY),
        e.container.dispatchEvent(
          new CustomEvent(n, { detail: { x: o.x, y: o.y } })
        );
    }
    function r(e) {
      0 !== e.deltaX && e.preventDefault(),
        n ||
          ((function (e) {
            (o = { x: e.pageX, y: e.pageY }), i(e, "ksDragStart");
          })(e),
          (n = !0)),
        (function (e) {
          i(e, "ksDrag");
        })(e),
        clearTimeout(t),
        (t = setTimeout(() => {
          (n = !1),
            (function (e) {
              i(e, "ksDragEnd");
            })(e);
        }, 50));
    }
    e.on("created", () => {
      e.container.addEventListener("wheel", r, { passive: !1 });
    });
  }
  const u = {
    productSelection: s,
    productSlider: window.component((t, o) => {
      const { sliderEl: n, nav: i, dotTemplate: r } = e(t, !1);
      function a(e) {
        const o = () => {
          i.querySelectorAll("div").forEach((e) => {
            e.remove();
          });
        };
        function n() {
          e.track.details?.slides.forEach((t, o) => {
            const n = document.createElement("div");
            (n.classList = r.classList),
              n.addEventListener("click", () => e.moveToIdx(o)),
              i.appendChild(n);
          });
        }
        function a() {
          const t = e.track.details?.rel;
          i.querySelectorAll("div").forEach((e, o) => {
            o === t ? e.classList.add("active") : e.classList.remove("active");
          });
        }
        e.on("created", () => {
          n(),
            a(),
            t.querySelectorAll(".keen-slider__slide").forEach((e) => {
              e.classList.remove("hidden");
            });
        }),
          e.on("optionsChanged", () => {
            o(), n(), a();
          }),
          e.on("slideChanged", a),
          e.on("destroyed", o);
      }
      let c;
      const d = () => {
        window.innerWidth < 640 &&
          !c &&
          (c = new KeenSlider(
            n,
            {
              renderMode: "performance",
              mode: "free-snap",
              dragSpeed: 0.8,
              rubberband: !1,
              defaultAnimation: { duration: 1500 },
              drag: !0,
            },
            [a, p]
          )),
          window.innerWidth > 640 && c && (c.destroy(), (c = null));
      };
      l("Keen slider").then(() => {
        d();
      }),
        window.addEventListener("resize", d),
        o.on("variant:change", ({ variant: e }) => {
          const { id: t } = e;
          if (c) {
            const e = c.slides.findIndex((e) => e.dataset.variants.includes(t));
            c.moveToIdx(e);
          }
        });
    }),
    productRecommendations: window.component((e) => {
      const t = () => {
        const { url: t } = e.dataset;
        fetch(t)
          .then((e) => e.text())
          .then((t) => {
            const o = document.createElement("div");
            o.innerHTML = t;
            const n = o.querySelector(
              '[data-component="productRecommendations"]'
            );
            n &&
              n.innerHTML.trim().length &&
              ((e.innerHTML = n.innerHTML), window.app.mount());
          })
          .catch((e) => {
            console.error(e);
          });
      };
      new IntersectionObserver(
        (o, n) => {
          o[0].isIntersecting && (n.unobserve(e), t());
        },
        { rootMargin: "0px 0px 200px 0px" }
      ).observe(e),
        window.Shopify.designMode && t();
    }),
    productSidebarsParallax: window.component((t) => {
      const { sidebar: o, imagesSidebar: n } = e(t, !1);
      let i;
      new ResizeObserver((e) => {
        i &&
          Object.entries(i)?.forEach(([e, t]) => {
            window.removeEventListener(e, t);
          }),
          e.forEach(() =>
            ((e, o) => {
              e.style.removeProperty("position"),
                e.style.removeProperty("top"),
                o.style.removeProperty("position"),
                o.style.removeProperty("top");
              const n = e.offsetHeight - o.offsetHeight < 0 ? e : o,
                r = e.offsetHeight - o.offsetHeight < 0 ? o : e,
                a = t.getBoundingClientRect().y + window.scrollY,
                c = n.offsetHeight - window.innerHeight + a,
                d = c / (r.offsetHeight - window.innerHeight + a),
                s = () => {
                  const e = window.pageYOffset * d;
                  (n.style.transform = `translateY(-${e}px)`),
                    (n.style.marginBottom = `-${e}px`);
                };
              let l = !1;
              const p = () => {
                l ||
                  ((l = !0),
                  requestAnimationFrame(() => {
                    window.dispatchEvent(new CustomEvent("optimizedScroll")),
                      (l = !1);
                  }));
              };
              (n.style.position = "sticky"),
                (n.style.top = `${a}px`),
                c > 0 &&
                  window.innerWidth > 640 &&
                  (s(),
                  window.addEventListener("scroll", p),
                  window.addEventListener("optimizedScroll", s)),
                (i = { scroll: p, optimizedScroll: s });
            })(o, n)
          );
      }).observe(t);
    }),
    productSliderShopthelook: window.component((t, o) => {
      const {
        sliderEl: n,
        nav: i,
        dotTemplate: r,
        btnNext: a,
        btnPrev: c,
        btnsWrap: d,
        shopTheLookSlide: s,
      } = e(t, !1);
      if (![].concat(s).filter(Boolean).length) return;
      let u;
      const m = (e) => {
        const { slides: t } = e.track.details,
          o = ["opacity-0", "pointer-events-none"];
        c.classList[t[0].portion > 0 ? "add" : "remove"](...o),
          a.classList[t[t.length - 1].portion > 0 ? "add" : "remove"](...o),
          setTimeout(() => {
            (d.style.top =
              e.slides[0].querySelector("img").clientHeight / 2 + "px"),
              d.classList.add("active");
          }, 100);
      };
      function w(e) {
        function t() {
          (i.innerHTML = ""),
            e.track.details.slides.forEach((t, o) => {
              const n = document.createElement("div");
              (n.classList = r.classList),
                n.addEventListener("click", () => e.moveToIdx(o)),
                i.appendChild(n);
            });
        }
        function o() {
          const t = e.track.details.rel;
          i.querySelectorAll("div").forEach((e, o) => {
            o === t ? e.classList.add("active") : e.classList.remove("active");
          });
        }
        e.on("created", (e) => {
          t(),
            o(),
            e.slides.forEach((e) => {
              e.style.marginRight = 0;
            }),
            m(e);
        }),
          e.on("optionsChanged", () => {
            t(), o();
          }),
          e.on("slideChanged", (e) => {
            o(), m(e);
          }),
          e.on("dragged", (e) => {
            m(e);
          });
      }
      l("Keen slider").then(() => {
        u = new KeenSlider(
          n,
          {
            renderMode: "performance",
            mode: "free-snap",
            dragSpeed: 0.8,
            rubberband: !1,
            defaultAnimation: { duration: 1500 },
            drag: !0,
            slides: {
              perView: "auto",
              spacing: +window
                .getComputedStyle(t.querySelector(".keen-slider__slide"))
                .marginRight.replace("px", ""),
            },
          },
          [w, p]
        );
      }),
        a.addEventListener("click", () => u.next()),
        c.addEventListener("click", () => u.prev()),
        o.on("drawer-finishthelook", (e) => {
          const { open: t } = e["drawer-finishthelook"];
          t && (u.update(u.options, 0), m(u));
        });
    }),
    productSelectionShopthelook: window.component((t, i) => {
      const {
          productMainSelect: s,
          price: l,
          compareAtPrice: p,
          form: u,
          submit: m,
          option1Out: w,
          option2Out: h,
          option3Out: v,
          option: f,
          option1: g,
          option2: y,
          option3: b,
        } = e(t, !1),
        { product: L } = JSON.parse(
          t.querySelector(".js-product-json").innerHTML
        ),
        E = (e) => {
          (m.textContent = e.available
            ? m.dataset.text
            : n("product.sold_out")),
            (m.disabled = !e.available),
            c({ price: l, compareAtPrice: p, variant: e }),
            r({ product: L, variant: e, option1: g, option2: y, option3: b }),
            a({
              option1: g,
              option2: y,
              option3: b,
              option1Out: w,
              option2Out: h,
              option3Out: v,
            });
        };
      f &&
        (d({ product: L, option: f, productMainSelect: s, variantChange: E }),
        [].concat(f).forEach((e) => {
          e.addEventListener("change", () => {
            d({
              product: L,
              option: f,
              productMainSelect: s,
              variantChange: E,
            });
          });
        })),
        u.addEventListener("submit", (e) => {
          e.preventDefault(),
            (m.disabled = !0),
            o(
              u.elements.id.value ||
                u.elements.id.querySelector("[selected]").value,
              u.elements.quantity.value
            ).then(({ error: e }) => {
              e && alert(e),
                setTimeout(() => {
                  i.emit("drawer-cart", { "drawer-cart": { open: !0 } }),
                    i.emit("drawer-finishthelook", {
                      "drawer-finishthelook": { open: !1 },
                    });
                }, 300),
                (m.disabled = !1);
            });
        });
    }),
    formBackInStock: window.component((e) => {
      e.addEventListener("submit", (t) => {
        t.preventDefault();
        const o = new FormData(e),
          n = o.get("contact[back_in_stock]"),
          i = o.get("contact[email]");
        window.braze &&
          (window.braze.getUser().setEmail(i),
          window.braze.getUser().addToCustomAttributeArray("back-in-stock", n),
          window.braze.logCustomEvent("back-in-stock", {
            email: i,
            variantId: n,
          })),
          setTimeout(() => {
            e.submit();
          }, 300);
      });
    }),
  };
  window.app.add(u), window.app.mount();
})();
